<template lang="pug">
  div.margin-top
    app-modal-visualiza-pdf(
      v-if="showModalVisualizaPdf",
      @closeModal="closeModalVisualizaPdf",
      :titulo="tituloModal",
      :tipo="tipoModal",
      :isImagem="isImagem"
      :conteudo="conteudoModal",
      :conteudoSemId="conteudoModalSemid"
      :isVTN="false"
    )
    div
      div.upload-area(:id="id", v-show="showUpload")
        transition(name="idle-fade")
          div.content.content-idle(v-if="!loading && !success" :class="{'error-upload' : errors.length}")
            .info Arraste e solte ou clique para selecionar um arquivo.
            .format Formato(s) suportado(s): {{this.fileType.join(', ')}}
        span(v-if="!loading && errors.length").help.erro {{ errors[0] }}
        transition(name="width")
          el-row.content.content-loader(v-if="loading" :style="{width: (percentage < 20 ? 20 : percentage).toString() + '%'}")
            el-col.column(:span="12")
              div.name {{ fileName }}
              div.size {{ fileSize }} Kb
            transition(name="buttons-and-label-fade")
              el-col.column.right.float-left(v-if="success" :span="12")
                div.label Carregado com sucesso!

      app-resumable(
        :ref="id",
        :target="'publico/upload'",
        :fileType="fileType",
        :idDrop="id",
        :idInput="id",
        :fileTypeErrorCallback="fileTypeErrorCallback"
        @onSuccess="onSuccessEvent",
        @onError="onErrorEvent",
        @onProgress="onProgressEvent",
        @fileAdded="onFileAddedEvent"
        :maxSize="maxSize || null"
      )
    .margin-top
      p.label(v-if="files.length > 0") Anexos
      el-table(
        v-if="files.length > 0"
        :data="files"
      )
        el-table-column(
          prop="nome",
          label="Nome do Arquivo:"
        )
        el-table-column(
          width="120"
        )
          template(slot-scope='scope')
            .flex
              app-action-button(
                v-if="isEstadoMA || isEstadoBA",
                icone="eye",
                :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar Documento' ",
                @click="abrirDocumento(scope.row)",
                :disabled="!isDocumentoParaVisualizacao(scope.row)"
              )
              app-action-button(
                icone="download",
                v-if="exibirDownload",
                @click="downloadDocumentoCadastro(scope.row)",
                cor="#666666",
                text="Baixar Documento"
                :placement="posicaoTooltip"
              )
              app-action-button(
                icone="trash",
                v-if="exibirDelete",
                @click="removeFile(scope.row)",
                cor="#666666",
                text="Remover Documento"
              )
              app-action-button(
                v-if="alteraFoto && scope.row.tipo.id === 150"
                icone="image",
                @click="mudarTipo(scope.row)",
                cor="#666666",
                text="Mudar para assinatura"
              )
              app-action-button(
                v-if="alteraFoto && scope.row.tipo.id === 149"
                icone="signature",
                @click="mudarTipo(scope.row)",
                cor="#666666",
                text="Mudar para galeria"
              )
</template>

<script>

import AppActionButton from '@/components/AppActionButton'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppResumable from '@/components/AppResumable'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import utils from '@/utils/utils'
const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppActionButton,
    AppResumable,
    AppModalVisualizaPdf
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      style: null,
      success: false,
      loading: false,
      percentage: 0,
      fileName: '',
      fileSize: '',
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false
    }
  },

  props: {
    id: {
      type: String,
      required: true
    },
    files: {
      type: Array,
      required: false
    },
    fileType: {
      type: Array,
      required: false,
      default: () => ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'zip']
    },
    scope: {
      type: String,
      required: false
    },
    errors: {
      required: false,
      type: Array,
      default: () => []
    },
    exibirDownload: {
      type: Boolean,
      required: false,
      default: true
    },
    showAnexar: {
      type: Boolean,
      required: false,
      default: true
    },
    exibirDelete: {
      type: Boolean,
      required: false,
      default: true
    },
    maxSize: {
      type: Number
    },
    alteraFoto: {
      type: Boolean,
      required: false,
      default: false
    },
    showUpload: {
      type: Boolean,
      default: true
    },
    posicaoTooltip: {
      type: String,
      default: 'bottom'
    }
  },

  created () {

  },

  mounted () {
    if (this.documento) {
      this.loading = true
      this.success = true
      this.fileName = this.documento.nomeOriginal
      this.fileSize = this.formatFileSize(this.documento.tamanho)
      this.percentage = 100
    }
  },
  computed: {
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoBA () {
      return process.env.ESTADO === 'ba'
    }
  },
  methods: {
    uploadFile (res, file) {
      this.$emit('uploadFile', file)
    },
    getDownload (documento) {
      this.$emit('downloadDocumentoCadastro', documento)
    },
    removeFile (documento) {
      if (!documento.status) {
        this.$emit('removeFile', documento)
      }
    },
    mudarTipo (documento) {
      this.$emit('alteraTipoFoto', documento)
    },
    downloadDocumentoCadastro (documento) {
      this.$emit('downloadDocumentoCadastro', documento)
    },
    isExtensaoImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tituloModal = 'Visualizar Documento'
      this.tipoModal = 'DOCUMENTO_SEM_ID'
      this.conteudoModal = 0
      this.isImagem = this.isExtensaoImagem(documento)
      this.conteudoModalSemid = documento
      this.showModalVisualizaPdf = true
      this.tituloDocumento = documento.tipo.descricao
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },
    handleUploadError () {
      this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
        'Houve um erro ao enviar o arquivo.')
    },
    formatFileSize (input) {
      return parseFloat((input / 1000).toFixed(2)).toLocaleString('pt-BR').toString()
    },
    clear () {
      this.loading = false
      this.success = false
      this.fileName = ''
      this.fileSize = ''
      this.percentage = 0
    },
    fileTypeErrorCallback () {
      this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
        this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.fileType.join(', ')))
    },
    onSuccessEvent (value, fileKey) {
      this.success = true
      this.clear()
      this.$emit('uploadFile', {name: value.file.name, response: fileKey})
    },
    onFileAddedEvent (file) {
      this.$refs[this.id].uploadFile()
      this.loading = true
      this.fileName = file.file.name
      this.fileSize = this.formatFileSize(file.size)
    },
    onErrorEvent (message) {
      this.loading = false
    },
    onProgressEvent (progress) {
      this.percentage = progress
    }
  },

  watch: {
    documento: {

      handler (val) {
        if (val && !val.removed) {
          this.loading = true
          this.success = true
          this.fileName = val.nomeOriginal
          this.fileSize = this.formatFileSize(val.tamanho)
          this.percentage = 100
        } else {
          this.clear()
        }
      },

      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";
.upload {
  margin: 20px;
}
.margin-top {
  margin-top: 20px;
}
.flex {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.upload-area {
  width: 100%;
}

.float-left {
  float: left
}

.content {
  border-radius: 4px;
  width: 100%;
  height: 7rem;
  padding: 1rem;
}

.content-idle {
  background-color: $border-color;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .info {
    color: $font-dark-color;
  }
  .format {
    padding-top: 0.25rem;
    font-size: 0.9rem;
  }
}

.content-loader {
  background-color: $color-primary;
}

.label,
.name {
  color: $white;
}

.column {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.buttons {
  margin-top: 1rem;
  float: right;
}

.right {
  align-items: flex-end;
}

.label {
  font-weight: bold;
}

.size {
  color: $border-color;
}

.excluir {
  color: $error;
}

.excluir:hover {
  background-color: #fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}

.width-enter-active {
  transition: width 2s;
}

.width-enter {
  width: 20%;
}

.idle-fade-enter-active {
  transition: opacity 1s;
}

.idle-fade-enter {
  opacity: 0;
}

.buttons-and-label-fade-leave-active {
  transition: opacity 0.5s;
}

.buttons-and-label-fade-leave-to {
  opacity: 0;
}

.buttons-and-label-fade-enter-active {
  transition: opacity 3s;
}

.buttons-and-label-fade-enter {
  opacity: 0;
}

.error-upload {
  border: 1px solid $error;
  border-radius: 13px;
}

</style>



// WEBPACK FOOTER //
// src/components/AppAnexo.vue